import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../../../../Field'
import { FormikField } from '../../../../../Formik'
import { InputField } from '../../../../../Input'
import {
  REGISTRATION_FORM_EMAIL_MAX_LENGTH,
  REGISTRATION_FORM_FIELD_HEIGHT,
  REGISTRATION_FORM_FIELD_NAME_EMAIL,
} from '../../RegistrationForm.constants'

function EmailField({ disabled }) {
  const { t } = useTranslation()

  return (
    <FormikField
      Component={InputField}
      Field={FieldStackedLabel}
      disabled={disabled}
      fieldComponentProps={{
        label: t('Auth.SignUpEmailLabelKey'),
      }}
      height={REGISTRATION_FORM_FIELD_HEIGHT}
      maxLength={REGISTRATION_FORM_EMAIL_MAX_LENGTH}
      name={REGISTRATION_FORM_FIELD_NAME_EMAIL}
      placeholder={t('Auth.SignUpEmailPlaceholderKey')}
    />
  )
}

export default EmailField
